import { createHook, createStore, type StoreActionApi } from 'react-sweet-state';

import { type AgentDetails } from '@atlassian/conversation-assistant-service';

interface State {
	agentData: AgentDetails | undefined;
}

export type StoreApi = StoreActionApi<State>;
type Actions = typeof actions;

const setAgentInfo =
	(data: AgentDetails) =>
	({ setState }: StoreApi) => {
		setState({ agentData: data });
	};

const actions = {
	setAgentInfo,
};

const RovoAgentStore = createStore<State, Actions>({
	initialState: {
		agentData: undefined,
	},
	actions,
});

export const useRovoAgentState = createHook(RovoAgentStore, {
	selector: (state) => state.agentData,
});

export const useRovoAgentData = createHook(RovoAgentStore);
